module.exports = __webpack_public_path__ + "assets/static/png/mobsec2.3ca5709c8f0894930a3bbdb1b1433ef4.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/main/images/mobsec2.png
 ** module id = 497
 ** module chunks = 1
 **/